import React from 'react';
import { string, shape, bool } from 'prop-types';

const BaseCard = ({ dark = false, image, target, title, url }) => (
    <article className={`c-base-card ${dark ? 'c-base-card--dark' : ''}`}>
        <div className="c-base-card__image">
            {!!image && !!image.url && (
                <img
                    className="b-lazy"
                    data-src={image.url}
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    alt={image.alt}
                />
            )}
        </div>
        <div className="c-base-card__body">
            <a
                href={url}
                className="c-base-card__link"
                target={target || undefined}
            >
                <h3
                    className={`c-base-card__title ${
                        dark ? 'c-base-card__title--light' : ''
                    }`}
                >
                    {title}
                </h3>
            </a>
        </div>
    </article>
);

BaseCard.propTypes = {
    dark: bool,
    id: string,
    image: shape({ url: string, alt: string }).isRequired,
    target: string,
    title: string.isRequired,
    url: string.isRequired
};

export default BaseCard;
